<template>
  <b-form-group :label="label"
                label-for="name">
    <b-input-group>
      <b-form-input :id="name"
                  :name="name"
                  autocomplete="off"
                  :size="size"
                  :type="type"
                  v-model="inputValue"
                  v-validate="validate"
                  :state="errors.has(name) ? false : null"
                  :aria-describedby="name + 'Feedback'"
                  :class="{'text-right': alignRight}"
                  :placeholder="placeholder"
                  :disabled="disabled">
      </b-form-input>
      <slot></slot>
      <b-form-invalid-feedback :id="name + 'Feedback'">
        {{errors.first(name)}}
      </b-form-invalid-feedback>
    </b-input-group>
  </b-form-group>
</template>

<script>
  import dateValidator from "../services/DateValidator";

  export default {
    props: {
      label: {
        type: String,
      },
      name: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      value: {
        required: true
      },
      decimal: {
        type: Boolean,
        required: false,
        default: false
      },
      disabled: {
        default: false
      },
      validate: {
        default: ''
      },
      validator: {
        type: Object,
      },
      datepicker: {
        type: Boolean,
        default: false
      },
      minDays: {
        type: Number,
        required: false
      },
      maxDays: {
        type: Number,
        required: false
      },
      size: {
        required: false
      },
      autofocus: {
        required: false
      },
      alignRight: {
        required: false,
        default: false
      },
      type: {
        required: false,
        default: 'text'
      }
    },
    data() {
      return {
        inputValue: this.value,
      }
    },
    created() {
      this.$validator = this.validator
    },
    mounted() {
      if (this.datepicker) {
        let options = {
          'singleDatePicker': true,
          'cancelClass': 'btn-light',
          'applyButtonClasses': 'btn-success',
          locale: {
            format: 'DD.MM.YYYY'
          }
        };

        if (this.minDays !== undefined && this.maxDays !== undefined) {
          const component = this

          options.isInvalidDate = val => {
            const date = val.format(options.locale.format)
            const minDaysValid = dateValidator.minDays.validate(date, [component.minDays])
            const maxDaysValid = dateValidator.maxDays.validate(date, [component.maxDays])
            return !minDaysValid || !maxDaysValid
          }
        }

        $('#' + this.name)
          .daterangepicker(options)
          .change((e) => this.inputValue = e.target.value)

        this.inputValue = $('#' + this.name).val()
      }

      if (this.autofocus) {
        this.$el.querySelector('input').focus()
      }
    },
    methods: {
      commaToDot(val) {
        if (!val || typeof val === 'number') return val;
        return val.replace(/,/g, '.');
      }
    },
    watch: {
      inputValue() {
        let val = this.inputValue
        if (this.decimal) {
          val = this.commaToDot(val)
        }
        this.$emit('input', val)
      },
      value() {
        this.inputValue = this.value
      }
    }
  }
</script>
